var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPassClose = function SvgPassClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.027%",
    y1: "-13.722%",
    x2: "88.304%",
    y2: "109.457%",
    id: "passClose_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA88",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.404%",
    y1: "-54.318%",
    x2: "84.709%",
    y2: "147.336%",
    id: "passClose_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA88",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.404%",
    y1: "-54.318%",
    x2: "84.709%",
    y2: "147.336%",
    id: "passClose_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA88",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 16.81a10.37 10.37 0 0 1-5.543-1.61.773.773 0 0 1-.244-1.03.696.696 0 0 1 .98-.257 8.965 8.965 0 0 0 7.442.999c2.505-.773 4.588-2.609 5.748-5.066a2.006 2.006 0 0 0 0-1.7 9.707 9.707 0 0 0-3.508-4.024.773.773 0 0 1-.226-1.026.695.695 0 0 1 .973-.254 11.185 11.185 0 0 1 4.04 4.634c.45.958.45 2.082 0 3.04C17.85 14.38 14.101 16.822 10 16.81Zm-7.143-3.125a.695.695 0 0 1-.507-.223 11.409 11.409 0 0 1-2.012-2.946 3.587 3.587 0 0 1 0-3.04C2.669 2.547 8.034.088 13.06 1.645c.372.122.583.535.472.929-.11.393-.5.62-.877.51-4.36-1.35-9.015.784-11.038 5.061a2.007 2.007 0 0 0 0 1.702 9.904 9.904 0 0 0 1.747 2.56.778.778 0 0 1 .154.817.715.715 0 0 1-.66.462Z",
    fill: "url(#passClose_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.498a4.156 4.156 0 0 1-3.03-1.319.776.776 0 0 1-.195-.73.733.733 0 0 1 .51-.535c.25-.07.516.01.695.204a2.761 2.761 0 0 0 4.041 0c1.116-1.172 1.116-3.072 0-4.245a.778.778 0 0 1 .009-1.052.69.69 0 0 1 1.001-.009c1.226 1.288 1.592 3.224.929 4.907-.664 1.682-2.226 2.779-3.96 2.779ZM6.446 10.12c-.367 0-.674-.292-.71-.675a4.8 4.8 0 0 1-.022-.45c.003-2.486 1.92-4.5 4.286-4.503.147 0 .294.008.44.024.383.055.654.42.614.822-.04.404-.379.7-.764.67a2.773 2.773 0 0 0-2.204.76 3.074 3.074 0 0 0-.929 2.527c.04.412-.246.78-.638.821a.814.814 0 0 1-.073.004Z",
    fill: "url(#passClose_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.143 18a.715.715 0 0 1-.66-.463.778.778 0 0 1 .155-.818L17.353.211a.69.69 0 0 1 1.001.009c.276.29.28.757.009 1.052L2.648 17.78a.695.695 0 0 1-.505.22Z",
    fill: "url(#passClose_svg__c)"
  }))));
};
export default SvgPassClose;